module.exports = __webpack_public_path__ + "assets/img/fc138ff6c9a229856cffb083b33748d1.svg";